import { Box, Spinner, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import {
  WizardData,
  canRenameFile,
} from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal/types'
import EsignatureSettings from 'modules/documents/components/BulkFiles/_steps/EsignatureSettings/index'
import filesStore from 'modules/documents/components/Documents/store'
import FolderSelector from 'modules/documents/components/Folders/FolderSelector'
import useDocumentContextlessPolicies from 'modules/documents/hooks/useDocumentContextlessPolicies'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

interface Props {
  folders: Folder[]
  selectedFolder?: Folder
}

const UploadSettings = ({
  data,
  onDataChanged,
  folders,
  selectedFolder,
}: WizardStepRenderParams<WizardData> & Props) => {
  const { uploadType, combineFileName, esignatureRequest, additionalSignersAccessIds } = data
  const { loading, policies } = useDocumentContextlessPolicies()

  const canManageDefaultEmployeeFolder = policies?.employeeManageDefaultEmployeeFolder.can ?? false

  if (loading)
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <Box gap="s16" width="s400" padding="s24">
      {canRenameFile(uploadType, filesStore.files.length) && (
        <TextField
          label={i18n.t('split_documents.form.file_name')}
          value={combineFileName}
          mandatory
          onChange={(newFileName) => onDataChanged({ ...data, combineFileName: newFileName })}
          focused
        />
      )}
      <FolderSelector
        label={i18n.t('split_documents.assign_documents.destination_folder')}
        noneOption={canManageDefaultEmployeeFolder}
        initialFolder={selectedFolder}
        initialSpace={SPACES.EMPLOYEE_MY_DOCUMENTS}
        folders={folders}
        onChange={(folderId) => onDataChanged({ ...data, folderId })}
        tooltip={i18n.t('split_documents.assign_documents.folder_help_tooltip')}
      />
      <EsignatureSettings
        settings={{
          newEsignatureRequest: esignatureRequest,
          newAdditionalSignersAccessIds: additionalSignersAccessIds,
        }}
        onChange={({ newEsignatureRequest, newAdditionalSignersAccessIds }) =>
          onDataChanged({
            ...data,
            esignatureRequest: newEsignatureRequest,
            additionalSignersAccessIds: newAdditionalSignersAccessIds,
          })
        }
      />
    </Box>
  )
}

export default UploadSettings
